<div class="detail-page" *ngIf="showDetail as detail">
    <header class="detail-header">
        <div class="detail-header__inner">
            <div class="detail-header__left">
                <button type="button" class="icon-button" (click)="goBack()" aria-label="Back">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <img src="/copago-logo.png" alt="Copago Logo" class="brand-logo" />
            </div>

            <div class="detail-header__center">
                <div class="show-main-title">{{ detail.title }}</div>

                <div class="show-sub-row">
                    <div class="show-meta">
                        <mat-icon>calendar_today</mat-icon>
                        <span>{{ detail.dateLabel }}</span>
                    </div>

                    <div class="show-meta">
                        <mat-icon>schedule</mat-icon>
                        <span>{{ detail.timeLabel }}</span>
                    </div>

                    <div class="header-chips">
                        <span class="header-chip" *ngFor="let block of detail.blocks">{{ block }}</span>
                    </div>
                </div>
            </div>

            <div class="detail-header__right">

                <button type="button" class="header-action-button" routerLink="/blocklist-names"
                    [queryParams]="{ returnUrl: blocklistReturnUrl }">
                    <mat-icon>block</mat-icon>
                    <span>Blocklist</span>
                </button>

                <button type="button" class="icon-button" (click)="logout()" aria-label="Logout">

                    <mat-icon>logout</mat-icon>

                </button>

            </div>
        </div>
    </header>

    <main class="detail-content">
        <section class="content-wrapper">
            <div class="stats-grid">
                <article class="stat-card">
                    <div class="stat-icon stat-icon--orange">
                        <mat-icon>grid_view</mat-icon>
                    </div>
                    <div class="stat-text">
                        <div class="stat-value">{{ detail.occupiedTables }}</div>
                        <div class="stat-label">Belegte Tische</div>
                    </div>
                </article>

                <article class="stat-card">
                    <div class="stat-icon stat-icon--orange-light">
                        <mat-icon>event_available</mat-icon>
                    </div>
                    <div class="stat-text">
                        <div class="stat-value">{{ detail.confirmedReservations }}</div>
                        <div class="stat-label">Bestätigt</div>
                    </div>
                </article>

                <article class="stat-card">
                    <div class="stat-icon stat-icon--green">
                        <mat-icon>groups</mat-icon>
                    </div>
                    <div class="stat-text">
                        <div class="stat-value">{{ detail.guests }}</div>
                        <div class="stat-label">Gäste</div>
                    </div>
                </article>

                <article class="stat-card">
                    <div class="stat-icon stat-icon--red">
                        <mat-icon>cancel</mat-icon>
                    </div>
                    <div class="stat-text">
                        <div class="stat-value">{{ detail.canceledReservations }}</div>
                        <div class="stat-label">Storniert</div>
                    </div>
                </article>
            </div>

            <div class="reservations-header-row">
                <div class="reservations-title-wrap">
                    <h1>Reservierungen</h1>
                    <span class="count-badge">{{ detail.reservationsCount }}</span>
                </div>

                <div class="filter-wrapper">
                    <button type="button" class="select-button" [class.select-button--active]="isBlockDropdownOpen"
                        (click)="toggleBlockDropdown($event)">
                        <mat-icon>filter_alt</mat-icon>
                        <span>{{ selectedBlockFilterLabel }}</span>
                        <mat-icon>
                            {{ isBlockDropdownOpen ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                    </button>

                    <div class="custom-dropdown-panel" *ngIf="isBlockDropdownOpen" (click)="$event.stopPropagation()">
                        <button type="button" class="custom-dropdown-option" *ngFor="let option of blockFilterOptions"
                            [class.custom-dropdown-option--selected]="selectedBlockFilter === option.value"
                            (click)="selectBlockFilter(option.value)">
                            <mat-icon class="option-check">
                                {{ selectedBlockFilter === option.value ? 'check' : '' }}
                            </mat-icon>
                            <span>{{ option.label }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="tabs-row">
                <button type="button" class="tab-button" [class.tab-button--active]="activeTab === 'Alle'"
                    (click)="selectTab('Alle')">
                    Alle
                </button>

                <button type="button" class="tab-button" [class.tab-button--active]="activeTab === 'Bestätigt'"
                    (click)="selectTab('Bestätigt')">
                    Bestätigt
                </button>

                <button type="button" class="tab-button" [class.tab-button--active]="activeTab === 'Storniert'"
                    (click)="selectTab('Storniert')">
                    Storniert
                </button>

                <button type="button" class="tab-button" [class.tab-button--active]="activeTab === 'Umgebucht'"
                    (click)="selectTab('Umgebucht')">
                    Umgebucht
                </button>
            </div>

            <div class="reservation-filter-toolbar">
                <div class="reservation-search-box">
                    <mat-icon>search</mat-icon>
                    <input type="text" placeholder="Gast oder Tisch oder Reservierungsnamen  suchen..."
                        [(ngModel)]="searchFilter" />
                </div>

                <div class="reservation-filter-group">
                    <label>Quelle</label>
                    <select [(ngModel)]="selectedSourceFilter">
                        <option *ngFor="let source of sourceFilterOptions" [value]="source">
                            {{ source }}
                        </option>
                    </select>
                </div>

                <div class="reservation-filter-group">
                    <label>Platztyp</label>
                    <select [(ngModel)]="selectedPlaceTypeFilter">
                        <option *ngFor="let placeType of placeTypeFilterOptions" [value]="placeType">
                            {{ placeType }}
                        </option>
                    </select>
                </div>

                <button type="button" class="reservation-filter-reset" (click)="clearReservationFilters()"
                    *ngIf="hasActiveReservationFilters">
                    <mat-icon>close</mat-icon>
                    Filter zurücksetzen
                </button>
            </div>

            <div class="detail-table-card">
                <div class="detail-table">
                    <div class="detail-table__head">
                        <button type="button" class="sortable-header" (click)="toggleSort('guest')">
                            <span>Gast</span>
                            <mat-icon>{{ getSortIcon('guest') }}</mat-icon>
                        </button>

                        <button type="button" class="sortable-header align-center" (click)="toggleSort('persons')">
                            <span>Pers.</span>
                            <mat-icon>{{ getSortIcon('persons') }}</mat-icon>
                        </button>

                        <button type="button" class="sortable-header align-center" (click)="toggleSort('table')">
                            <span>Tisch</span>
                            <mat-icon>{{ getSortIcon('table') }}</mat-icon>
                        </button>

                        <button type="button" class="sortable-header" (click)="toggleSort('block')">
                            <span>Zeitblock</span>
                            <mat-icon>{{ getSortIcon('block') }}</mat-icon>
                        </button>

                        <button type="button" class="sortable-header" (click)="toggleSort('amount')">
                            <span>Betrag</span>
                            <mat-icon>{{ getSortIcon('amount') }}</mat-icon>
                        </button>

                        <button type="button" class="sortable-header" (click)="toggleSort('status')">
                            <span>Status</span>
                            <mat-icon>{{ getSortIcon('status') }}</mat-icon>
                        </button>

                        <button type="button" class="sortable-header" (click)="toggleSort('source')">
                            <span>Quelle</span>
                            <mat-icon>{{ getSortIcon('source') }}</mat-icon>
                        </button>

                        <button type="button" class="sortable-header" (click)="toggleSort('placeType')">
                            <span>Platztyp</span>
                            <mat-icon>{{ getSortIcon('placeType') }}</mat-icon>
                        </button>

                        <div class="align-center">Aktionen</div>
                    </div>

                    <ng-container *ngIf="filteredReservations.length; else emptyReservations">
                        <div class="detail-table__row"
                            *ngFor="let reservation of filteredReservations; trackBy: trackByReservationId">
                            <div class="guest-cell">
                                <div class="guest-name">{{ reservation.guestName }}</div>

                                <div class="guest-real-name"
                                    *ngIf="reservation.realGuestName !== reservation.guestName">
                                    {{ reservation.realGuestName }}
                                </div>

                                <div class="guest-phone">{{ reservation.phone }}</div>
                            </div>

                            <div class="align-center value-strong">{{ reservation.persons }}</div>
                            <div class="align-center">{{ reservation.table }}</div>

                            <div class="block-cell">
                                <div class="block-name">{{ reservation.block }}</div>
                                <div class="block-time">{{ reservation.blockTime }}</div>
                            </div>

                            <div class="value-strong">{{ reservation.amount }}</div>

                            <div>
                                <span class="status-pill" [ngClass]="{
                                        'status-pill--confirmed': reservation.status === 'Bestätigt',
                                        'status-pill--canceled': reservation.status === 'Storniert',
                                        'status-pill--canceled-by-user': reservation.status === 'Benutzerstorno',
                                        'status-pill--moved': reservation.status === 'Umgebucht'
                                    }">
                                    {{ reservation.status }}
                                </span>
                            </div>

                            <div>
                                <span class="source-pill">
                                    <mat-icon>
                                        {{
                                        reservation.source === 'Web'
                                        ? 'public'
                                        : reservation.source === 'Kasse'
                                        ? 'desktop_windows'
                                        : 'admin_panel_settings'
                                        }}
                                    </mat-icon>
                                    <span>{{ reservation.source }}</span>
                                </span>
                            </div>

                            <div>
                                <span class="place-type-pill"
                                    [class.place-type-pill--standing]="reservation.targetPlaceType === 1">
                                    {{ getPlaceTypeLabel(reservation) }}
                                </span>
                            </div>

                            <div class="actions-cell" [class.actions-cell--single]="reservation.status !== 'Bestätigt'">
                                <button type="button" class="table-icon-button table-icon-button--hover-orange"
                                    aria-label="View" [disabled]="isSubmittingAction"
                                    (click)="openReservationDetails(reservation)">
                                    <mat-icon>visibility</mat-icon>
                                </button>

                                <ng-container *ngIf="reservation.status === 'Bestätigt'">
                                    <button type="button" class="table-icon-button table-icon-button--hover-orange"
                                        aria-label="Move" [disabled]="isSubmittingAction"
                                        (click)="openRebookModal(reservation)">
                                        <mat-icon>sync_alt</mat-icon>
                                    </button>

                                    <button type="button" class="table-icon-button"
                                        [class.table-icon-button--hover-orange]="reservation.source !== 'Kasse'"
                                        [class.table-icon-button--danger]="reservation.source !== 'Kasse'"
                                        [class.table-icon-button--disabled]="reservation.source === 'Kasse'"
                                        [disabled]="reservation.source === 'Kasse' || isSubmittingAction"
                                        aria-label="Cancel" (click)="cancelReservation(reservation)">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <ng-template #emptyReservations>
                    <div class="empty-state">
                        {{ emptyStateText }}
                    </div>
                </ng-template>
            </div>
        </section>
    </main>

    <div class="page-loader-overlay" *ngIf="isPageLoading">
        <div class="page-loader-card">
            <mat-spinner diameter="44"></mat-spinner>
            <div class="page-loader-text">Daten werden geladen ...</div>
        </div>
    </div>
</div>